<template>
  <layout name="Clean">
    <div class="fw">
      <div class="sign-up-wrapper">
        <div class="logo-wrapper">
          <img :src="logo" />
        </div>
        <VDialogWindowsSequence :pages="pages"></VDialogWindowsSequence>
      </div>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

import Layout from "@/layouts/Layout";
import VDialogWindowsSequence from "@/components/VDialogWindowsSequence";

import SignUpIntroducingForm from "@/components/SignUpIntroducingForm";
import SignUpPasswordForm from "@/components/SignUpPasswordForm";
import SignUpReturnAddressForm from "@/components/SignUpReturnAddressForm";
import SignUpBillingForm from "@/components/SignUpBillingForm";

import withNavigate from "@/mixins/withNavigate";

import CampaignLogo from "@/assets/images/campaign_logo.svg";

export default Vue.component("SignUp", {
  props: {},

  components: {
    Layout,
    VDialogWindowsSequence,
    SignUpIntroducingForm,
    SignUpPasswordForm,
    SignUpReturnAddressForm,
    SignUpBillingForm
  },

  mixins: [withNavigate],

  data() {
    return {
      logo: CampaignLogo,
      isPasswordSet: Boolean(localStorage.getItem("passwordSet"))
    };
  },

  computed: {
    pages() {
      return [
        {
          pageNumber: 1,
          title: "Tell Us About Yourself",
          description:
            "You're about to create an Inkit account, exciting! Please note that your new account will be created only when you finish setting up your password.",
          component: SignUpIntroducingForm
        },

        {
          pageNumber: 2,
          title: this.isPasswordSet
            ? "Password has been set"
            : "Choose a password",
          description: !this.isPasswordSet
            ? "Your password needs to be at least 8 characters. It can contain letters, numbers, and punctuation characters. Don't use a password from another site or something too obvious like your pet's name."
            : "",
          component: SignUpPasswordForm
        },

        {
          pageNumber: 3,
          title: "Create Your Return Address",
          description:
            "The return address is used as a default address when setting up your account. This information can be edited and modified inside the settings page.",
          component: SignUpReturnAddressForm
        },

        {
          pageNumber: 4,
          title: "Billing information",
          description: "Fill the billing information below.",
          component: SignUpBillingForm
        }
      ];
    },

    ...mapGetters("account", ["identity"])
  },

  created() {
    if (this.identity && this.identity.account) {
      const { active_payment, information_filled } = this.identity.account;

      if (active_payment) {
        this.navigate("/dashboard");
      } else if (information_filled && !active_payment) {
        this.navigate("/payment");
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.fw {
  height: 100%;
  display: grid;
}
.sign-up-wrapper {
  padding: 30px 0;
  display: grid;
  grid-gap: 40px;
  justify-content: center;
  align-content: center;

  .logo-wrapper {
    text-align: center;
  }

  img {
    height: 40px;
  }

  /*@media screen and (max-height: 768px) {*/
  /*  height: auto;*/
  /*  margin: 20px 0;*/
  /*}*/
}
</style>
